
import { BaseService } from '../base/base.service';
import { AppService } from '../main/app.service';

export class ILead {
    id: string;
}

export class LeadsService extends BaseService<ILead> {
    constructor(Restangular: Restangular.IService, protected AppService: AppService) {
        "ngInject";
        super(Restangular, AppService, 'crm/leads');
    }
}


// WEBPACK FOOTER //
// ./src/app/services/leads.service.ts